<template>
    <div id="app">
        <component :is="layout">
            <router-view/>
        </component>
    </div>
</template>

<script>

    import MainLayout from "./layout/MainLayout";
    import EmptyLayout from "./layout/EmptyLayout";

    export default {
        name: 'App',
        components: {MainLayout, EmptyLayout},
        metaInfo: {
            title: 'Главная',
            titleTemplate: '%s | Foodison Курьер'
        },
        computed: {
            layout() {
                return (this.$route.meta.layout || 'main') + '-layout';
            },
        },
        mounted() {
            this.$vuetify.theme.dark = JSON.parse(localStorage.getItem('theme.dark'))
            console.log('++++++++++++++++++++++++ localStorage(\'theme.dark\', this.$vuetify.theme.dark)', localStorage('theme.dark', this.$vuetify.theme.dark))

        }
    };
</script>

<style scoped>

</style>
